import { useMemo } from 'react';
import { ApiTimeZone } from 'src/models/api-configuration/api-configuration.model';
import { getFormattedStartEnd } from './use-date-display.helper';

export interface DateDisplayProps {
    date: string;
    showTime?: boolean;
    timeZone?: ApiTimeZone;
    endDate?: string;
    useErsDateOnlyHack?: boolean;
}

export const useDateDisplay = ({
    date,
    showTime,
    timeZone,
    endDate,
    useErsDateOnlyHack,
}: DateDisplayProps) => {
    return useMemo(() => {
        return getFormattedStartEnd(date, endDate, { showTime, timeZone, useErsDateOnlyHack });
    }, [date, endDate, showTime, timeZone, useErsDateOnlyHack]);
};
